export interface StatusBarProps {
  q: number;
  ug: number;
  precise: boolean;
  showAC: boolean;
  tramosAF: number;
  tramosAC: number;
  accesorios: number;
  brand: string;
  routingLabel: string;
}

export function StatusBar(_: StatusBarProps): JSX.Element {
  return (
    <div className="statusbar">
      <span className="grow" />
      <span>Derechos reservados, SanPlumb 2026.</span>
      <span className="grow" />
    </div>
  );
}
